/*
	ISI (scroll events and click events)
 */

    isi = {
        init: function(){
            $html = document.getElementsByTagName('html')[0];
            isi.cE();
        },
        cE: function cacheElements(){
            /*
             * cache elements that get reused. keep your code DRY!
             */

            isi.body = document.body;
            isi.headerNav = document.querySelector(".main-header");
            isi.mainFooter = $('.main-footer');
            isi.isiBarWrapper = $('.isi-bar-wrapper');

            isi.mainSection = document.querySelector('.main-section');
            isi.footerISI = document.querySelector('footer.main-footer');
            isi.bodyHeight = null;
            isi.pageHeight = null;
            isi.viewportHeight = null;
            isi.headerHeight = null;
            isi.isiHeight = null;

            isi.scrollDirection = null;
            isi.scrollDistance  = null;
            isi.scrollStart     = window.scrollY || window.pageYOffset;
            isi.scrollLast      = 0;
            isi.scroll          = null;
            isi.hiding          = false; // indicates that we're hiding the header
            isi.scrollDownPar   = 100; // this indicates how far down to scroll before hiding the header
            isi.scrollUpPar     = 25; // this indicates how far up before showing the header again
            isi.isiCompact      = false; // if the ISI is in it's compacted state
            isi.isiCompactVar   = 100;

            isi.el();
            isi.sE();
            isi.rE();
        },
        el: function eventListenters(){
            /**
             ISI EVENT
             **/
            $(".toggle-isi").on("click", isi.toggleIsi );
            $('.collapse-isi').on('click', function(e){
                e.preventDefault();
                isi.compactISI();
            });
            $(".back-to-top-isi").on("click", isi.backToTopIsi);

            //	ON LOAD EVENT FOR SHADOW DIV
            if( !document.body.classList.contains("results") ) {
                $('window').on('load', isi.checkHeight());
            }
        },
        sE: function scrollEvents(){
            /* IE11 - sticky wasn't working and the polyfills didn't seem to fix it. */
            var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

            if(isIE11) {
                // console.log("Is IE11");
                var isiBarWrapperOffset = null,
                    hasResetIsiBarWrapperOffset = false;
                window.addEventListener('scroll', function(){

                    if (document.getElementsByTagName('html')[0].classList.contains('isi--is--detached')) {
                        // console.log("is detached",hasResetIsiBarWrapperOffset);
                        if(!hasResetIsiBarWrapperOffset) {
                            // console.log("no hasResetIsiBarWrapperOffset", hasResetIsiBarWrapperOffset)
                            isiBarWrapperOffset = isi.isiBarWrapper.offset().top;
                            hasResetIsiBarWrapperOffset = true;
                        }
                        //console.log(window.pageYOffset, isiBarWrapperOffset, window.pageYOffset >= isiBarWrapperOffset);
                        if(window.pageYOffset >= isiBarWrapperOffset) {
                            if(!isi.isiBarWrapper[0].classList.contains('lock-for-ie')) {
                                isi.isiBarWrapper[0].classList.add('lock-for-ie')
                            }
                        } else {
                            if(isi.isiBarWrapper[0].classList.contains('lock-for-ie')) {
                                isi.isiBarWrapper[0].classList.remove('lock-for-ie')
                            }
                        }
                    }
                })
            }
            // SCROLL EVENT FOR ISI
            $(window).on('scroll', function(){
                var scrollTop 			= gliv.returnScrollTop();
                isi.scrollLast 		= isi.scroll;
                isi.scroll     		= window.scrollY || window.pageYOffset;
                isi.viewportHeight = gliv.returnWindowHeight();
                isi.headerHeight 	= 80;
                isi.isiHeight 			= 125;
                isi.bodyHeight 		= gliv.getElDimension(isi.body, true).height;

                // Header show/hide on scroll
                if (! $html.classList.contains('ignore-page-scrolling')) {
                    // console.log("DOES NOT have ignore-page-scrolling");
                    if (isi.scroll > isi.scrollLast) {
                        // console.log('is greater');
                        // console.log('scrolling down', isi.scrollDirection);
                        if (isi.scrollDirection === "down" || isi.scrollDirection == null) {
                            // console.log("scroll dir is down or scrollDirection is NULL");
                            isi.scrollDirection = "down";
                            isi.scrollDistance  = Math.abs(isi.scrollStart - window.pageYOffset);
                        } else {
                            isi.scrollReset("down");
                        }
                    } else {
                        if (isi.scrollDirection === "up" || isi.scrollDirection === null) {
                            isi.scrollDirection = "up";
                            isi.scrollDistance  = Math.abs(isi.scrollStart - window.pageYOffset);
                        } else {
                            isi.scrollReset("up");
                        }
                    }
                }

                isi.viewportHeight = gliv.returnWindowHeight();
                isi.headerHeight   = gliv.getElDimension(isi.headerNav, true).height;
                isi.isiHeight      = gliv.getElDimension(isi.footerISI, true).height;
                isi.bodyHeight     = gliv.getElDimension(isi.body, true).height;

                if (!$html.classList.contains("show-isi")){
                    // console.log(isi.bodyHeight, isi.viewportHeight, Math.round(scrollTop), isi.bodyHeight - isi.viewportHeight);
                    if (Math.round(scrollTop) >= isi.bodyHeight - isi.viewportHeight){
                        $html.classList.add('isi--is--detached');
                    } else {
                        if ($html.classList.contains('isi--is--detached')) {
                            $html.classList.remove('isi--is--detached');
                        }
                    }
                }
            });
        },
        rE: function resizeEvents(){
            window.addEventListener('resize', function () {
                //Chrome specific bug that causes the resize event to be triggered when the print window is closed, which in turn causes the shadow div to resize to 0 and then the isi cannot open.
                var isChrome = !!window.chrome && !!window.chrome.webstore;
                if (isChrome && $html.classList.contains('print-btn-clicked')){

                } else {
                    isi.checkHeight();
                    isi.updateCompactedISIHeight();
                }
            });
        },
        scrollReset: function (dir) {
            isi.scrollDirection = dir;
            isi.scrollStart     = window.pageYOffset;
        },
        compactISI: function () {
            // console.log('gonna collapse');
            document.querySelector('.main-footer').classList.add('has-collapsed');
            document.getElementsByTagName('body')[0].classList.add('footer-collapsed');
            isi.isiCompact = true;
            if (gliv.returnWindowWidth() > 800){
                specificPatients.calculateTabContentHeight();
            }
        },
        updateCompactedISIHeight: function(){
            if (document.querySelector('.main-footer').classList.contains('has-collapsed') &&
                document.getElementsByTagName('body')[0].classList.contains('footer-collapsed')){
                if (gliv.returnWindowWidth() > 768){
                    isi.mainFooter.css({
                        'height': '30px'
                    });
                } else {
                    isi.mainFooter.css({
                        'height': '60px'
                    });
                }
            }
        },
        checkHeight: function(){
            var mainH   = Math.max($("[data-role='content']").height()),
                headerH = Math.max($('header').height()),
                h       = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            if ((mainH + headerH) <= h){
                var difference = h - (mainH + headerH);
                isi.addShadowDiv(difference);
            } else {
                isi.removeShadowDiv();
            }
        },
        addShadowDiv: function(diff){
            var shadowHeight = diff + "px";
            if (!$html.classList.contains('shadow-div-exists')){
                $("[data-role='content']").append('<div class="shadow-div"></div>');
                $html.classList.add('shadow-div-exists');
                // debugger;
                $('.shadow-div').css('height', shadowHeight);
            } else {
                // debugger;
                $('.shadow-div').css('height', shadowHeight);
            }
        },
        removeShadowDiv: function(){
            if ($html.classList.contains('shadow-div-exists')){
                // debugger;
                $('.shadow-div').remove();
                $html.classList.remove('shadow-div-exists');
            }
        },
        backToTopIsi: function(evt){
            evt.preventDefault();
            evt.stopPropagation();
            if ($html.classList.contains('isi--is--detached')) {
                if ($(".isi--is--detached").length > 0){
                    $html.classList.remove('isi--is--detached');
                    $("html, body").animate({ scrollTop: 0 }, "slow");
                }
            } else {
                // Add 'show-isi' class to Footer and HTML
                $html.classList.remove("show-isi");
                isi.mainFooter.removeClass('is--open');
                isi.mainFooter.css({
                    'height': ''
                });
                // Remove height styling to prevent isi from scrolling while closed
                document.getElementsByClassName('main-isi isi')[0].style.height = "";
                $("html, body").animate({ scrollTop: 0 }, "slow");
            }
        },
        toggleIsi:function(evt){
            evt.preventDefault();
            evt.stopPropagation();
            if ($html.classList.contains('isi--is--detached')) {
                if ($(".isi--is--detached").length > 0){
                    $html.classList.remove('isi--is--detached');
                    $("html, body").animate({ scrollTop: 0 }, "slow");
                }
            } else if ($html.classList.contains('show-isi')) {
                // Add 'show-isi' class to Footer and HTML
                $html.classList.remove('show-isi');
                isi.mainFooter.removeClass('is--open');
                isi.compactISI();
                if (gliv.returnWindowWidth() > 768){
                    isi.mainFooter.css({
                        'height': '30px'
                    });
                } else {
                    isi.mainFooter.css({
                        'height': '60px'
                    });
                }
                // Remove height styling to prevent isi from scrolling while closed
                document.getElementsByClassName('main-isi isi')[0].style.height = '';
            } else {
                // Add 'show-isi' class to Footer and HTML
                $html.classList.add('show-isi');
                isi.mainFooter.addClass('is--open');
                if ($(document).scrollTop() > 80){
                    isi.mainFooter.css({
                        'height': '100%'
                    });
                } else {
                    var amountHeaderShowing = 80 - $(document).scrollTop();
                    isi.mainFooter.css('height', 'calc(100% - '+amountHeaderShowing+'px)');
                }
                // If navigation is open, close it
                if ($('body.show-main-navigation')){
                    $("body").removeClass("show-main-navigation");
                    nav.removeSVGtransform();
                }
            }
        }
    };
